import { FunctionComponent } from 'react'
import useStyles from './styles'
import { ResumeDoctorGroupProps } from './types'
import { Avatar, Text, Box } from '@conexasaude/conexa-hero'
import DivisorLine from '@/components/DivisorLine'
const ResumeDoctorGroup: FunctionComponent<ResumeDoctorGroupProps> = ({
  professionalSpecialty,
  professionalName,
}) => {
  const styles = useStyles()
  return (
    <div css={styles.container}>
      <Box>
        <div css={styles.containerBox}>
          <Text renderAs="h5" variant="headingSmall">
            Quem irá te atender
          </Text>
        </div>
        <DivisorLine />
        <div css={styles.wrapperData}>
          <Avatar src="" size="large" />
          <div css={styles.wrapperText}>
            <Text>Consulta com</Text>
            <Text renderAs="span">{professionalName}</Text>
            <Text renderAs="span">{professionalSpecialty}</Text>
          </div>
        </div>
      </Box>
    </div>
  )
}

export default ResumeDoctorGroup
